export default __webpack_public_path__ + "static/media/avatar.75f60aec.jpg";